import { type ElementType } from "react";
import Card from "./Card";
import Text from "./Text";
import styles from "./InfoItem.module.css";

interface InfoItemProps {
  icon: ElementType;
  label: string;
  value: string;
}

export default function InfoItem({ icon: Icon, label, value }: InfoItemProps) {
  return (
    <Card padding="xs" className={styles.infoItem}>
      <div className={styles.infoIcon}>
        <Icon size={20} />
      </div>
      <div>
        <Text variant="deci" weight="medium" color="muted">
          {label}
        </Text>
        <Text variant="deci" weight="bold">
          {value}
        </Text>
      </div>
    </Card>
  );
}
